export interface UrlValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export const validateUrl = (
  value?: string,
  required: boolean = false
): UrlValidationResult => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return {
      isValid: !required,
      errorMessage: required ? 'URL is required' : undefined,
    };
  }

  if (!URL_REGEX.test(trimmedValue)) {
    return {
      isValid: false,
      errorMessage: 'Please enter a valid url',
    };
  }

  return { isValid: true };
};
